// @flow

import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from './shared/Typography';

import illoGardening from '.././assets/illustrations/illo-membership-promo.png';

import AndroidButton from './shared/ButtonAndroid';
import IOSButton from './shared/ButtonIOS';

type MembershipProps = {
  free: boolean,
  currentPlan?: boolean
}

// eslint-disable-next-line no-unused-vars
const MemberBenefits = ({ free }: MembershipProps) => {
  const { t } = useTranslation('membershipCard');
  return (
    <ul className='user-profile__membership-benefits'>
      <li><Text paragraph>{t('health_care_providers')}</Text></li>
      <li><Text paragraph bold> &emsp;&emsp;{t('with_each_request')}</Text></li>
      <li><Text paragraph icon='check--green'>{t('get_health_records')}</Text></li>
      <li><Text paragraph icon='check--green'>{t('have_labs_digitized')}</Text></li>
    </ul>
  );
};

const MembershipContent = ({ free, currentPlan }: MembershipProps) => {
  const { t } = useTranslation('membershipCard');
  return (
    <div className='plan'>
      <Text h2 bold>
        {currentPlan
          && <Text span bold className='user-profile__membership-tag'>{t('my_plan')}</Text>}
      </Text>
      <MemberBenefits free={free} />
      <Text className='user-profile__membership-cost' paragraph bold>
        {t('price')}
      </Text>
      <div className='user-profile__membership-apps'>
        <Text paragraph bold>{t('head_to_mobile_app')}</Text>
        <AndroidButton />
        <IOSButton />
      </div>
    </div>
  );
};

const MembershipCard = ({ free }: MembershipProps) => {
  const { t } = useTranslation('membershipCard');
  return (
    <div className={'user-profile__membership'}>
      <MembershipContent free={free} currentPlan />
      <img className='user-profile__image' src={illoGardening} alt={t('alt_text')} />
    </div>
  );
};

export default MembershipCard;



// WEBPACK FOOTER //
// ./src/components/membership-card.js